export default __webpack_public_path__ + "static/media/MoldingImg.de1ed217.png";